class StickyMediaGallery {
  constructor() {
    this.mediaGallery = document.querySelector('.product__media-gallery');
    this.stylistTipBlock = document.querySelector('.stylist-tip-block');
    this.header = document.querySelector('sticky-header') || document.querySelector('header');
    this.mediaWrapper = document.querySelector('.product__media-wrapper');
    
    if (!this.mediaGallery) return;
    
    this.STICKY_THRESHOLD = 50;
    this.PADDING_BOTTOM = 160;
    this.HEADER_OFFSET = 50;
    
    this.init();
  }

  init() {
    this.setupScrollListener();
    this.updateDimensions();
    
    const resizeObserver = new ResizeObserver(() => this.updateDimensions());
    resizeObserver.observe(this.mediaWrapper);
  }

  updateDimensions() {
    if (this.mediaWrapper) {
      this.galleryWidth = this.mediaWrapper.offsetWidth;
    }
  }

  setupScrollListener() {
    let ticking = false;
    
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', onScroll, { passive: true });
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset;
    const headerHeight = this.header?.offsetHeight || 0;
    const isHeaderSticky = scrollTop > this.STICKY_THRESHOLD;
    
    const shouldUnstick = this.checkShouldUnstick(scrollTop, headerHeight);
    
    this.updateGalleryState(isHeaderSticky, shouldUnstick, headerHeight);
  }

  checkShouldUnstick(scrollTop, headerHeight) {
    if (!this.stylistTipBlock) return false;
    
    const stylistTipTop = this.stylistTipBlock.getBoundingClientRect().top + scrollTop;
    const galleryBottom = scrollTop + headerHeight + this.mediaGallery.offsetHeight + this.PADDING_BOTTOM;
    
    return galleryBottom >= stylistTipTop;
  }

  updateGalleryState(isHeaderSticky, shouldUnstick, headerHeight) {
    const gallery = this.mediaGallery;
    const width = `${this.mediaWrapper.offsetWidth}px`;
    
    if (isHeaderSticky && !shouldUnstick) {
      gallery.classList.toggle('is-sticky', true);
      gallery.classList.toggle('is-bottom', false);
      gallery.style.cssText = `width: ${width}; top: ${headerHeight + this.HEADER_OFFSET}px;`;
    } else if (shouldUnstick) {
      gallery.classList.toggle('is-sticky', false);
      gallery.classList.toggle('is-bottom', true);
      gallery.style.cssText = `width: ${width}; bottom: 0;`;
    } else {
      gallery.classList.remove('is-sticky', 'is-bottom');
      gallery.style.cssText = '';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyMediaGallery();
  });
} else {
  new StickyMediaGallery();
}
